// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 1px !important;
  border: none !important;
  --border-radius: 26px !important;
  --border-color: var(--color-black);
  --border-radius: 5px;
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-input {
  --border: none !important;
  color: #8e8e8e;
  font-family: AppFontBold, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent ;
}

.privacy {
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--ion-color-primary);
  text-transform: capitalize;
}

.privacy-btn {
  margin-left: 5px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

.stacked {
  position: relative;
  z-index: 2;
  left: 20px;
  top: 7px;
  padding: 0px 5px;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
}

ion-checkbox {
  margin-left: 0px;
}

.stacked {
  position: static;
  top: 0px;
  left: 0px;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: #8e8e8e;
  font-family: AppFontBold, sans-serif;
}
.input-age ion-input:first-child {
  border-right: 1px solid var(--color-black);
}
.input-age ion-input:last-child {
  border-left: 1px solid var(--color-black);
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  margin: 10px 0px;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #F6F1EF;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal ion-item {
  --background: #F6F1EF;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper-modal .close-icon:hover {
  background: #f2dbd9;
}
.wrapper-modal .title-text {
  width: 100%;
  font-family: AppFontMedium, sans-serif;
  font-size: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  color: var(--color-black);
  padding-top: 2px;
  margin-bottom: 15px;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-size: 24px;
  }
}
.wrapper-modal .subtitle-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    font-size: 16px;
  }
}
.wrapper-modal .header-block {
  padding: 10px;
  flex-grow: 1;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 30px 30px 0px;
  }
}
.wrapper-modal .footer-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-modal .footer-section .delete-user {
  width: -moz-fit-content;
  width: fit-content;
  height: 36px;
  padding: 10px 15px;
  border: 1px solid #811B0F;
  border-radius: 26px;
  color: #811B0F;
  text-transform: uppercase;
  margin-bottom: 30px;
  font-family: AppFontMedium;
  font-size: 14px;
  letter-spacing: 0.08em;
  cursor: pointer;
  text-transform: uppercase;
}

.update-user {
  padding: 10px;
  width: 100%;
  border-top: 0.5px solid var(--color-black-alt);
}
.update-user ion-button {
  width: 100%;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}

ion-label {
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-family: AppFontSemiBold;
    font-size: 14px;
  }
}

.update-btn {
  --background: #ebdfda;
  color: var(--color-black);
  width: 100%;
}
.update-btn:hover {
  --background:#F2DBD9;
}`, "",{"version":3,"sources":["webpack://./src/app/components/user-data-modal/user-data-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAGA;EACE,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,kCAAA;EACA,oBAAA;EACA,mBAAA;AAAF;AAEE;EACE,2BAAA;AAAJ;;AAGA;EACE,yBAAA;EACA,cAAA;EACA,oCAAA;AAAF;;AAEA;EACE,kBAAA;EACA,0BAAA;AACF;;AAEA;EACE,eAAA;EACA,6BAAA;AACF;AAAE;EACE,YAAA;EACA,+BAAA;EACA,0BAAA;AAEJ;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,mBAAA;AAEF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EAEE,gBAAA;AAAF;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,gBAAA;AAAF;;AAIA;EACC,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AADD;;AAGA;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;AAAF;;AAGE;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,oCAAA;AAAJ;AAEE;EACE,0CAAA;AAAJ;AAEE;EACE,yCAAA;AAAJ;;AAGA;EACE,yBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAEF;AADE;EACE,WAAA;EACA,gBAAA;AAGJ;AADE;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAEJ;AADI;EACI,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAGR;;AAEA;EAOI,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AALJ;ACpIE;ED0HF;IAEI,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EAYF;AACF;AAFI;EACE,qBAAA;AAIN;AAFI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAIN;AAHM;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAKR;AAHM;EACE,mBAAA;AAKR;AAFI;EACE,WAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAIN;ACnLE;EDsKE;IAYI,eAAA;EAKN;AACF;AAHI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;AAKN;AChME;EDqLE;IAQI,eAAA;EAON;AACF;AALI;EACI,aAAA;EAIA,YAAA;AAIR;ACzME;EDgME;IAGQ,sBAAA;EAUV;AACF;AANI;EACE,WAAA;EACA,aAAA;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;AAQV;AAPM;EACE,uBAAA;EAAA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EAEA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;AAQR;;AAHA;EACE,aAAA;EACA,WAAA;EACA,8CAAA;AAMF;AALE;EACE,WAAA;AAOJ;;AAJA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAOD;;AAJA;EACC,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACC,sBAAA;AAOF;ACtPE;ED0OF;IAQI,4BAAA;IACA,eAAA;EAQF;AACF;;AADA;EACE,qBAAA;EACA,yBAAA;EACA,WAAA;AAIF;AAHE;EACE,oBAAA;AAKJ","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\nion-item {\n  --border-width: 1px !important;\n  border: none !important;\n  --border-radius: 26px !important;\n  --border-color: var(--color-black);\n  --border-radius: 5px;\n  margin-bottom: 12px;\n\n  &.no-line {\n    --border-color: transparent;\n  }\n}\nion-input {\n  --border: none !important;\n  color: #8e8e8e;\n  font-family: AppFontBold, sans-serif;\n}\n.no-line {\n  border-bottom: 0px;\n  --background: transparent\n}\n\n.privacy{\n  font-size: 12px;\n  color: var(--ion-color-black);\n  ion-button {\n    padding: 0px;\n    color: var(--ion-color-primary);\n    text-transform: capitalize;\n  }\n}\n.privacy-btn{\n  margin-left: 5px;\n}\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\n\n.stacked {\n  position: relative;\n  z-index: 2;\n  left: 20px;\n  top: 7px;\n  padding: 0px 5px;\n}\n\n.terms {\n\n  margin-left: 0px;\n  ion-checkbox {\n    margin-right: 10px;\n  }\n}\n\nion-checkbox {\n  margin-left: 0px;\n}\n\n\n.stacked {\n\tposition: static;\n\ttop: 0px;\n\tleft: 0px;\n\tz-index: 2;\n}\nion-label {\n  font-family: AppFontBold, sans-serif;\n  font-size: 16px;\n  color: var(--color-black);\n}\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: #8e8e8e;\n    font-family: AppFontBold, sans-serif;\n  }\n  ion-input:first-child {\n    border-right: 1px solid var(--color-black);\n  }\n  ion-input:last-child {\n    border-left: 1px solid var(--color-black);;\n  }\n}\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  ion-button {\n    width: 100%;\n    margin: 10px 0px\n  }\n  ion-button {\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    p {\n        margin-top: 5px;\n        font-family: AppFontBold, sans-serif;\n        color: white;\n        width: 75%;\n    }\n}\n\n}\n.wrapper-modal {\n  @include mobile {\n    margin-top: 25px;\n    border-bottom: none;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n    border-radius: 26px;\n    height: 100%;\n    position: relative;\n    overflow: auto;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    background: #F6F1EF;\n    ion-item {\n      --background: #F6F1EF;\n    }\n    .close-icon {\n      position: absolute;\n      top: 15px;\n      right: 15px;\n      margin: 0px;\n      background: var(--color-white-accent);\n      width: 35px;\n      height: 35px;\n      padding: 0px;\n      z-index: 99;\n      ion-icon {\n        width: 100%;\n        height: 100%;\n        margin: 0px;\n      }\n      &:hover {\n        background: #f2dbd9;\n      }\n    }\n    .title-text {\n      width: 100%;\n      font-family: AppFontMedium, sans-serif;\n      font-size: 14px;\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n      text-align: center;\n      color: var(--color-black);\n      padding-top: 2px;\n      margin-bottom: 15px;\n  \n      @include desktop {\n        font-size: 24px;\n      }\n    }\n    .subtitle-text {\n      width: 100%;\n      text-align: center;\n      color: var(--color-black);\n      text-transform: uppercase;\n      font-family: AppFont, sans-serif;\n      padding: 10px;\n      @include desktop {\n        font-size: 16px;\n      }\n    }\n    .header-block {\n        padding: 10px;\n        @include desktop {\n            padding: 30px 30px 0px;\n        }\n        flex-grow: 1\n        ;\n    }\n    .footer-section {\n      width: 100%;\n      display: flex;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n      .delete-user {\n        width: fit-content;\n        height: 36px;\n        padding: 10px 15px;\n        border: 1px solid #811B0F;\n        border-radius: 26px;\n        color: #811B0F;\n        text-transform: uppercase;\n        margin-bottom: 30px;\n\n        font-family: AppFontMedium;\n        font-size: 14px;\n        letter-spacing: 0.08em;\n        cursor: pointer;\n        text-transform: uppercase;;\n      }\n     \n    }\n}\n.update-user {\n  padding: 10px;\n  width: 100%;\n  border-top:0.5px solid var(--color-black-alt);\n  ion-button {\n    width: 100%;\n  }\n}\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n}\n\nion-label {\n\tfont-family: AppFontBold, sans-serif;\n\tfont-size: 16px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n  letter-spacing: 0.08em;\n\n  @include mobile {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n  }\n}\n\n.input-age::part(native) {\n  // --border-style: none;\n}\n\n.update-btn {\n  --background: #ebdfda;\n  color:var(--color-black);\n  width: 100%;\n  &:hover {\n    --background:#F2DBD9;\n\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
